import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination'; // if you want pagination dots
import 'swiper/css/navigation'; // if you want arrows
import { Pagination } from 'swiper/modules';

const Staff = (props) => {
  return (
    <>
      <div className="row gy-4">
        <div className="row justify-content-center section-title text-center">
          <div className="col-lg-7">
            <h3 className="font-alt">{props.site.staffPageTitle}</h3>
            <p className="body">{props.site.staffDescription}</p>
          </div>
        </div>
        {/* {ServiceContent.map((val, i) => (
          <div
            className="col-sm-6 col-lg-4"
            key={i}
          >
            <div className="feature-box-02">
              <h6>
                {val.service}
              </h6>
              <p>{val.desc}</p>
            </div>
          </div>
        ))} */}

<Swiper
  spaceBetween={20}
  slidesPerView={1}
  pagination={{ clickable: true }}
  modules={[Pagination]}
  breakpoints={{
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  }}
>
  {props.site.staff.map((val, i) => (
    
    <SwiperSlide key={i}>
      <div className="staff-box">
        <div style={{textAlign:"center"}}>
          <img loading='lazy' alt="profile" style={{width:"11rem", borderRadius:"50%"}} src={process.env.REACT_APP_API_SERVICE_BASE_URL+"image/BarberProfileImages/" + val.imageFileName}></img>
        </div>
      </div>
          <h6 className="heading-6" style={{textAlign:"center", borderBottom:"none", marginTop:"1rem"}}>
            {val.name}
          </h6>
    </SwiperSlide>
  ))}
</Swiper>
        
      </div>
    </>
  );
};

export default Staff;
